import { getIntersectionKeys as F, mapObject as b } from "./util.js";
function v(t) {
  "@babel/helpers - typeof";
  return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, v(t);
}
function P(t) {
  return x(t) || q(t) || _(t) || K();
}
function K() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function q(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function x(t) {
  if (Array.isArray(t)) return A(t);
}
function w(t, r) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function i(t) {
  for (var r = 1; r < arguments.length; r++) {
    var e = arguments[r] != null ? arguments[r] : {};
    r % 2 ? w(Object(e), !0).forEach(function(n) {
      O(t, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : w(Object(e)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return t;
}
function O(t, r, e) {
  return r = H(r), r in t ? Object.defineProperty(t, r, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : t[r] = e, t;
}
function H(t) {
  var r = V(t, "string");
  return v(r) === "symbol" ? r : String(r);
}
function V(t, r) {
  if (v(t) !== "object" || t === null) return t;
  var e = t[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(t, r);
    if (v(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(t);
}
function W(t, r) {
  return N(t) || M(t, r) || _(t, r) || L();
}
function L() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _(t, r) {
  if (t) {
    if (typeof t == "string") return A(t, r);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return A(t, r);
  }
}
function A(t, r) {
  (r == null || r > t.length) && (r = t.length);
  for (var e = 0, n = new Array(r); e < r; e++) n[e] = t[e];
  return n;
}
function M(t, r) {
  var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (e != null) {
    var n, a, l, o, c = [], f = !0, y = !1;
    try {
      if (l = (e = e.call(t)).next, r !== 0) for (; !(f = (n = l.call(e)).done) && (c.push(n.value), c.length !== r); f = !0) ;
    } catch (m) {
      y = !0, a = m;
    } finally {
      try {
        if (!f && e.return != null && (o = e.return(), Object(o) !== o)) return;
      } finally {
        if (y) throw a;
      }
    }
    return c;
  }
}
function N(t) {
  if (Array.isArray(t)) return t;
}
var S = function(r, e, n) {
  return r + (e - r) * n;
}, j = function(r) {
  var e = r.from, n = r.to;
  return e !== n;
}, R = function t(r, e, n) {
  var a = b(function(l, o) {
    if (j(o)) {
      var c = r(o.from, o.to, o.velocity), f = W(c, 2), y = f[0], m = f[1];
      return i(i({}, o), {}, {
        from: y,
        velocity: m
      });
    }
    return o;
  }, e);
  return n < 1 ? b(function(l, o) {
    return j(o) ? i(i({}, o), {}, {
      velocity: S(o.velocity, a[l].velocity, n),
      from: S(o.from, a[l].from, n)
    }) : o;
  }, e) : t(r, a, n - 1);
};
const z = function(t, r, e, n, a) {
  var l = F(t, r), o = l.reduce(function(p, u) {
    return i(i({}, p), {}, O({}, u, [t[u], r[u]]));
  }, {}), c = l.reduce(function(p, u) {
    return i(i({}, p), {}, O({}, u, {
      from: t[u],
      velocity: 0,
      to: r[u]
    }));
  }, {}), f = -1, y, m, d = function() {
    return null;
  }, T = function() {
    return b(function(u, s) {
      return s.from;
    }, c);
  }, I = function() {
    return !Object.values(c).filter(j).length;
  }, C = function(u) {
    y || (y = u);
    var s = u - y, h = s / e.dt;
    c = R(e, c, h), a(i(i(i({}, t), r), T())), y = u, I() || (f = requestAnimationFrame(d));
  }, U = function(u) {
    m || (m = u);
    var s = (u - m) / n, h = b(function(D, g) {
      return S.apply(void 0, P(g).concat([e(s)]));
    }, o);
    if (a(i(i(i({}, t), r), h)), s < 1)
      f = requestAnimationFrame(d);
    else {
      var E = b(function(D, g) {
        return S.apply(void 0, P(g).concat([e(1)]));
      }, o);
      a(i(i(i({}, t), r), E));
    }
  };
  return d = e.isStepper ? C : U, function() {
    return requestAnimationFrame(d), function() {
      cancelAnimationFrame(f);
    };
  };
};
export {
  z as default
};
